import React from 'react';
import PropTypes from 'prop-types';
import ButtonBraun from '../../../common/ButtonBraun';
import styles from './styles.module.css';
import data from '../../../data';


const DiscoverComponent = ({
  className,
  elementClassName,
  title,
  subTitle,
  elements,
}) => {

  const general = data.general;

  const clickDiscover = (url) => {
    if (typeof window !== `undefined`) {
      window.open(url, '_blank');
    }
  };

  return (
    <>
      <div
        className={`${className} ${styles.discoversWrapper}`}>
        {/* title */}
        {title && subTitle &&
        <div className={styles.discoverMainMessage}>
          <div dangerouslySetInnerHTML={{ __html: title }} />
          <div dangerouslySetInnerHTML={{ __html: subTitle }} />
        </div>}
        {/* element list */}
        <div className={styles.discoverElementList}>
          {elements && elements.map((element, index) => {
            return (
              <div
                className={`${elementClassName}-${index + 1} ${styles.discoverElement}`}
                key={index}>
                {/* element image */}
                {element?.image && <div className={styles.discoverImage}>
                  <img src={element.image} alt={`${element.name} - ${element.description}`} />
                </div>}
                {/* timeline texts */}
                <div className={styles.nameAndDescription}>
                  {element?.name && <div className={styles.discoverName}>{element.name}</div>}
                  {element?.description && <div className={styles.discoverDescription}>{element.description}</div>}
                </div>
                {/* element button */}
                {element?.url &&
                <ButtonBraun
                  text={general.discover}
                  customStyles={styles.btn}
                  theme="dark"
                  onClickEvent={() => clickDiscover(element.url)}
                />}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

DiscoverComponent.propTypes = {
  className: PropTypes.string,
  elementClassName: PropTypes.string,
  timelineIconClassName: PropTypes.string,
  descriptionClassName: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  elements: PropTypes.array,
};

export default DiscoverComponent;